import { Button } from '@/shared/components/ui/button';
import { Card, CardContent } from '@/shared/components/ui/card';
import { useNavigate } from '@tanstack/react-router';
import { AlertCircle, Home, RotateCcw } from 'lucide-react';
import React from 'react';

interface ErrorBoundaryProps {
  error?: Error;
  resetError?: () => void;
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  error,
  resetError,
}) => {
  const navigate = useNavigate();

  const handleGoHome = () => navigate({ to: '/' });

  const handleReload = () => {
    if (resetError) resetError();
    else window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ruda-bg-secondary p-6">
      <Card className="max-w-lg w-full">
        <CardContent className="flex flex-col items-center gap-4 pt-8 text-center">
          <AlertCircle className="h-16 w-16 text-destructive" />
          <h2 className="text-xl font-semibold">페이지를 불러올 수 없습니다</h2>
          <p className="text-muted-foreground">
            요청하신 페이지를 불러오는 중 오류가 발생했습니다.
          </p>
          {error && (
            <div className="w-full rounded-12 border border-destructive/20 bg-destructive/10 p-3 text-sm text-destructive">
              {error.message || '알 수 없는 오류가 발생했습니다.'}
            </div>
          )}
          <div className="flex gap-2 pt-2">
            <Button onClick={handleGoHome}>
              <Home className="mr-2 h-4 w-4" />
              홈으로 이동
            </Button>
            <Button variant="outline" onClick={handleReload}>
              <RotateCcw className="mr-2 h-4 w-4" />
              다시 시도
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export const DefaultErrorComponent: React.FC = () => <ErrorBoundary />;
